
export function renderAiopsRag () {
    return (
  <div className="py-10 font-display">
      {/* Global styles for scrollbar, glass utility and animations */}
      <style>{`
        /* Custom scrollbar */
        ::-webkit-scrollbar { width: 8px; height:8px; }
        ::-webkit-scrollbar-track { background: #050505; }
        ::-webkit-scrollbar-thumb { background: #1f2923; border-radius: 4px; }
        ::-webkit-scrollbar-thumb:hover { background: #13ec5b; }

        /* Glass card */
        .glass-card {
          background: rgba(16,22,18,0.6);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          border: 1px solid rgba(255,255,255,0.05);
        }

        /* small helpers used in the original design */
        .grid-bg { background-image: radial-gradient(rgba(255,255,255,0.02) 1px, transparent 1px); background-size: 20px 20px; }
        .diagram-node { padding: 0.75rem; border-radius: 0.75rem; display:flex; flex-direction:column; align-items:center; justify-content:center; text-align:center; position:relative; z-index:10; transition: all .2s; box-shadow: 0 6px 18px rgba(2,6,23,0.2); }
        .diagram-node:hover { transform: translateY(-6px); }

        /* animations */
        @keyframes pulse-slow { 0% { transform: scale(1) } 50% { transform: scale(1.03) } 100% { transform: scale(1) } }
        .animate-pulse-slow { animation: pulse-slow 4s cubic-bezier(.4,0,.6,1) infinite; }

        @keyframes fade-in-up { 0% { opacity: 0; transform: translateY(10px);} 100% { opacity: 1; transform: translateY(0);} }
        .animate-fade-in-up { animation: fade-in-up 0.45s ease both; }

        /* small responsive tweak so layout doesn't overflow on very small screens */
        @media (max-width: 640px) {
          .hide-sm { display:none; }
        }
      `}</style>

          {/* Main Content */}
          <main className="transition-opacity duration-300">
            {/* Breadcrumb */}
            <div className="flex items-center gap-2 text-sm text-slate-500 mb-8">
              <span>Platform</span>
              <span className="material-symbols-outlined text-[14px]">chevron_right</span>
              <span>Netraa AIOps</span>
              <span className="material-symbols-outlined text-[14px]">chevron_right</span>
              <span className="text-primary">RAG Documentation Intelligence</span>
            </div>

        {/* Hero */}
        <section className="relative mb-24 scroll-mt-24" id="knowledge-bridge">
          
          <div className="mb-8">
            <h1 className="text-5xl lg:text-5xl font-extrabold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">

              Docs-Aware Reasoning through RAG:{" "}
              <span className="text-black dark:text-white">
                Bridging Knowledge &amp; Operations
              </span>
            </h1>

            <p className="text-lg text-slate-600 dark:text-slate-300 leading-relaxed">
              Stop scrambling for runbooks during an incident. Netraa vectorizes your technical documentation, transforming passive wikis into an active, conversational knowledge engine.
            </p>
          </div>

              {/* 3D Vector Space Graphic (visual hero) */}
              <div className="w-full aspect-[16/9] md:aspect-[21/9] rounded-2xl overflow-hidden relative group border border-border-dark bg-surface-dark shadow-2xl shadow-primary/5">
                <div className="absolute inset-0 bg-[linear-gradient(rgba(19,236,91,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(19,236,91,0.03)_1px,transparent_1px)] bg-[size:40px_40px]"></div>
                <div className="absolute inset-0 bg-gradient-to-t from-background-dark via-transparent to-transparent"></div>

                {/* Glowing center hub */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 flex flex-col items-center">
                  <div className="relative">
                    <div className="absolute inset-0 bg-primary blur-[60px] opacity-20 rounded-full animate-pulse"></div>
                    <div className="glass-card px-6 py-4 rounded-xl border-primary/30 flex items-start gap-3 max-w-sm shadow-[0_0_30px_rgba(19,236,91,0.15)] transform transition-transform hover:scale-105 duration-500">
                      <div className="size-8 rounded-full bg-gradient-to-br from-primary to-green-700 flex items-center justify-center text-black font-bold shrink-0">
                        <span className="material-symbols-outlined text-sm">smart_toy</span>
                      </div>
                      <div>
                        <p className="text-xs text-primary font-bold mb-1">Netraa AI</p>
                        <p className="text-sm text-white">Based on the Dynatrace runbook, this anomaly correlates with high memory usage on node-04.</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* floating beams / icons */}
                <div className="absolute top-1/4 left-1/4 animate-bounce duration-[3000ms]">
                  <div className="flex flex-col items-center gap-2">
                    <span className="material-symbols-outlined text-4xl text-slate-500">description</span>
                    <span className="text-xs text-slate-500 font-mono">PDF Manuals</span>
                    <div className="h-24 w-[1px] bg-gradient-to-b from-slate-700 to-primary/50 origin-bottom rotate-[-30deg]"></div>
                  </div>
                </div>

                <div className="absolute bottom-1/4 right-1/4 animate-bounce duration-[4000ms]">
                  <div className="flex flex-col items-center gap-2">
                    <div className="h-24 w-[1px] bg-gradient-to-t from-slate-700 to-primary/50 origin-top rotate-[-30deg]"></div>
                    <span className="material-symbols-outlined text-4xl text-slate-500">folder_open</span>
                    <span className="text-xs text-slate-500 font-mono">Internal Wiki</span>
                  </div>
                </div>

                <img alt="Network Graphic" className="absolute inset-0 object-cover opacity-20 mix-blend-overlay pointer-events-none" src="https://lh3.googleusercontent.com/aida-public/AB6AXuAFdzOw-gwKKnY51-uj4yc6IHWUtqFGhB6dgpK35HIANbe9Ei8lVzPP8_VObZ64dcBzIYLxkO9NVJg8ribAe2oxHay4VrK_WTG7N_rX6KnFVWHpQx1buXpk3aIsy_xO9DM-OIYzL69QsrI6zrhdvp1_B1lM_N0ONgfxZF5ewCStvDdvhRnoB_RnKZdekDCI3oBWdZ5MI6WQDJXDyJ-TjIDuS3_HsZ0GdIdwuW6v9mTXwpTiz4kON_z6zfFN3Hlhyfoqjcz1jFh1KiY" />
              </div>
            </section>

{/* The Problem */}
<section className="grid lg:grid-cols-2 gap-12 items-center mb-24 scroll-mt-24" id="operational-scramble">
  <div className="order-2 lg:order-1">
    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-500/10 border border-red-500/20 text-red-500 dark:text-red-400 text-xs font-bold uppercase tracking-wider mb-4">
      <span className="size-2 rounded-full bg-red-500 animate-pulse"></span>
      The Problem
    </div>

    <h2 className="text-3xl font-bold text-slate-900 dark:text-white mb-6">
      Fragmented Knowledge &amp; Slow MTTR
    </h2>

    <p className="text-slate-700 dark:text-slate-400 mb-6 text-lg">
      Operational knowledge is typically fragmented across outdated wikis, PDF manuals, and scattered vendor docs.
    </p>

    <p className="text-slate-700 dark:text-slate-400 mb-8 text-lg">
      Competitors lack RAG-based intelligence, leaving engineers to manually search for answers while the clock ticks, significantly slowing down Mean Time To Resolution (MTTR).
    </p>

    <div className="flex items-center gap-4 text-sm font-mono text-slate-600 dark:text-slate-500">
      <div className="flex items-center gap-2">
        <span className="material-symbols-outlined text-red-500">timer</span>
        <span>High MTTR</span>
      </div>
      <div className="h-4 w-px bg-slate-300 dark:bg-slate-700"></div>
      <div className="flex items-center gap-2">
        <span className="material-symbols-outlined text-red-500">search_off</span>
        <span>Manual Search</span>
      </div>
    </div>
  </div>

  <div className="order-1 lg:order-2 relative group"> <div className="absolute -inset-1 bg-gradient-to-r from-red-500/20 to-orange-500/20 rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-1000"></div> <div className="relative rounded-2xl bg-surface-dark border border-border-dark aspect-square overflow-hidden flex items-center justify-center p-8"> <div className="relative w-full h-full flex items-center justify-center"> <span className="material-symbols-outlined text-6xl text-slate-700 absolute top-10 left-10 rotate-12 opacity-50">description</span> <span className="material-symbols-outlined text-5xl text-slate-600 absolute bottom-20 right-10 -rotate-12 opacity-50">folder_off</span> <span className="material-symbols-outlined text-7xl text-slate-800 absolute top-1/2 right-20 rotate-45 opacity-50">broken_image</span> <div className="relative z-10 flex flex-col items-center"> <span className="material-symbols-outlined text-8xl text-red-400 mb-4 animate-pulse">warning</span> <div className="bg-red-500/10 border border-red-500/30 px-4 py-2 rounded text-red-400 font-mono text-sm"> Error: Documentation Not Found </div> </div> </div> </div> </div>
</section>


{/* The Solution */}
<section
  id="rag-assistant"
  className="py-24 scroll-mt-24"
>
  <div className="mx-auto px-6">

    {/* Header */}
    <div className="text-center mx-auto mb-16">

      {/* Badge */}
      <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full
        bg-emerald-500/10 border border-emerald-500/30
        text-emerald-600 dark:text-emerald-400
        text-xs font-semibold uppercase tracking-wider mb-6">

        <span className="material-symbols-outlined text-[16px]">
          check_circle
        </span>
        The Solution
      </div>

      <h2 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-6 leading-tight">
        Merging Observability with <br className="hidden md:block" />
        Knowledge
      </h2>

      <p className="text-slate-600 dark:text-slate-400 text-lg">
        Netraa doesn't just see the alerts; it reads the manual for you.
      </p>
    </div>

    {/* Cards */}
    <div className="grid md:grid-cols-2 gap-8">

      {/* Card 1 */}
      <div className="rounded-2xl p-8 transition-all duration-300 hover:-translate-y-2
        bg-white dark:bg-[#07140f]
        border border-slate-200 dark:border-emerald-500/10
        shadow-sm dark:shadow-none
        hover:border-emerald-500/40">

        <div className="w-14 h-14 rounded-xl
          bg-emerald-500/10 dark:bg-emerald-500/5
          border border-emerald-500/20
          flex items-center justify-center mb-6">

          <span className="material-symbols-outlined text-emerald-600 dark:text-emerald-400 text-3xl">
            topic
          </span>
        </div>

        <h3 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">
          1. Vectorized Intelligence
        </h3>

        <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed">
          Ingest everything. We instantly vectorize runbooks, vendor PDFs, and wiki pages into a high-performance vector database ready for retrieval.
        </p>
      </div>

      {/* Card 2 */}
      <div className="rounded-2xl p-8 transition-all duration-300 hover:-translate-y-2
        bg-white dark:bg-[#07140f]
        border border-slate-200 dark:border-emerald-500/10
        shadow-sm dark:shadow-none
        hover:border-emerald-500/40">

        <div className="w-14 h-14 rounded-xl
          bg-emerald-500/10 dark:bg-emerald-500/5
          border border-emerald-500/20
          flex items-center justify-center mb-6">

          <span className="material-symbols-outlined text-emerald-600 dark:text-emerald-400 text-3xl">
            chat
          </span>
        </div>

        <h3 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">
          2. Natural Language Queries
        </h3>

        <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed">
          Ask anything. Type questions directly into your operational workflow like "How do I restart the Kafka consumer group safely?"
        </p>
      </div>

      {/* Card 3 */}
      <div className="rounded-2xl p-8 transition-all duration-300 hover:-translate-y-2
        bg-white dark:bg-[#07140f]
        border border-slate-200 dark:border-emerald-500/10
        shadow-sm dark:shadow-none
        hover:border-emerald-500/40">

        <div className="w-14 h-14 rounded-xl
          bg-emerald-500/10 dark:bg-emerald-500/5
          border border-emerald-500/20
          flex items-center justify-center mb-6">

          <span className="material-symbols-outlined text-emerald-600 dark:text-emerald-400 text-3xl">
            lightbulb
          </span>
        </div>

        <h3 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">
          3. Context-Aware Synthesis
        </h3>

        <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed">
          Instant answers. The AI acts as your 24/7 knowledge-augmented operational assistant, synthesizing data from multiple docs into one answer.
        </p>
      </div>

    </div>
  </div>
</section>

          </main>
        </div>
  );
}